<!-- eslint-disable no-console -->
<template>
  <FormContainer :title="title">
    <div class="form-item" style="margin-top: 66px;">
      <Input v-model="groupName" placeholder="请输入报名ID" />
    </div>
    <div class="form-item">
      <Input v-model="userName" placeholder="请输入姓名" />
    </div>
    <div class="form-item">
      <Button @click="submit" :disabled="disabled">查询</Button>
    </div>
  </FormContainer>
</template>
<script>
import Input from './input.vue'
import Button from './button.vue'
import FormContainer from './form-container.vue'
export default {
  components: {
    Input,
    Button,
    FormContainer
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    groupName: '',
    userName: '',
    disabled: false,
  }),
  computed: {
  },
  methods: {
    submit() {
      // eslint-disable-next-line no-console
      // console.log(this.groupName, this.userName)
      if (!this.groupName || !this.userName) {
        this.$message.showMessage({ info: '请输入报名ID和姓名' })
        return
      }
      this.disabled = true
      this.$emit('submit', { groupName: this.groupName, userName: this.userName })
      setTimeout(() => {
        this.disabled = false
      }, 2000)
    },
  },
}
</script>
<style lang="less" scoped>
.form-item {
    margin: 0 auto;
    width: 426px;
    margin-top: 24px;
  }
</style>